import styled from '@emotion/styled';

const GridWrapper = styled.div`
  display: grid;
  
  > * {
      position: relative;
  }

  > *::after {
      content: '';
      position: absolute;
      display: block;
      position: absolute;
      background-size: cover;
      background-repeat: no-repeat;
  }

  > *:last-child::after {
      display: none;
  }

  grid-template-columns: 1fr;
  gap: 40px;
  max-width: 89%;

  > *:nth-of-type(even) {
    transform: translateX(12.5%);
  }

  > *::after {
    width: 50px;
    height: 40px;
    top: 100%;
  }

  > *:nth-of-type(odd)::after {
    background-image: url(/images/path_graphics/small_right.svg);
    left: 45%;
  }

  > *:nth-of-type(even)::after {
    background-image: url(/images/path_graphics/small_left.svg);
    right: 45%;
  }
`;

export default GridWrapper;